module.exports = __webpack_public_path__ + "merriweather-regular-webfont.755502607743f9c957a5.eot";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/merriweather-regular-webfont.eot
// module id = ../../../../../src/assets/fonts/merriweather-regular-webfont.eot
// module chunks = 2